import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const showNavUrls = ['/', '/search', '/map', 'menu'];

  const showNav = showNavUrls.some(
    (p) => !!matchPath({ path: p, end: true }, location.pathname),
  );

  const tapList = [
    {
      label: '홈',
      imgName: 'home',
      url: '/',
    },
    {
      label: '땅집봇',
      imgName: 'chatbot',
      url: '/chat',
    },
    {
      label: '검색',
      imgName: 'auction',
      url: '/search',
    },
    {
      label: '지도',
      imgName: 'map',
      url: '/map',
    },
    {
      label: '전체메뉴',
      imgName: 'menu',
      url: '/menu',
    },
  ];

  const isActive = (url: string) =>
    !!matchPath({ path: url, end: url === '/' }, location.pathname) ||
    (!!matchPath({ path: `${url}/*`, end: false }, location.pathname) &&
      url !== '/');

  if (!showNav) return null;
  return (
    <Container>
      <TabContainer>
        {tapList.map((item) => (
          <Tab
            key={item.label}
            onClick={() => {
              if (item.label === '땅집봇') {
                window.open(item.url, '_blank');
              } else {
                navigate(item.url);
              }
            }}
          >
            <Inner>
              <img
                src={`/assets/images/nav/${item.imgName}${isActive(item.url) ? '-active' : ''}.svg`}
                alt=""
              />
              <Label $isActive={isActive(item.url)}>{item.label}</Label>
            </Inner>
          </Tab>
        ))}
      </TabContainer>
    </Container>
  );
}

export default BottomNav;

const TabContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 900px;
  display: flex;
  align-items: center;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 0 10px 0 rgba(220, 228, 232, 0.3);
  background: #fff;
`;

const Container = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1000;
  display: flex;
  width: 100%;
  height: 54px;
  align-items: center;
  justify-content: center;

  user-select: none;
`;

const Tab = styled.div`
  display: flex;
  height: 54px;
  padding: 0 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`;

const Label = styled.div<{ $isActive?: boolean }>`
  color: ${({ $isActive }) =>
    $isActive ? 'rgba(0, 12, 30, 0.80)' : 'rgba(0, 25, 54, 0.31)'};
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;
